import { Flex, Button } from '@chakra-ui/react'
import moment from 'moment'

export const RenderPresets = ({
  onPresetClick,
  maxDataRange,
}: {
  onPresetClick: ({
    startDate,
    endDate,
  }: {
    startDate: moment.Moment
    endDate: moment.Moment
  }) => void
  maxDataRange?: [moment.Moment, moment.Moment]
}) => {
  const presets = [
    {
      text: 'Last 3 months',
      start: moment().subtract(3, 'months').startOf('day'), // 3 months ago
      end: moment().endOf('day'),
    },
    {
      text: 'Last 3 years',
      start: moment().subtract(3, 'years').startOf('day'), // 3 years ago
      end: moment().endOf('day'),
    },
    {
      text: 'Year to date',
      start: moment().startOf('year'), // beginning of this year
      end: moment().endOf('day'),
    },
    ...(maxDataRange
      ? [
          {
            text: 'Max data range',
            start: maxDataRange[0],
            end: maxDataRange[1],
          },
        ]
      : []),
  ]

  return (
    <Flex gap={2}>
      {presets.map(({ text, start, end }) => {
        return (
          <Button
            size={'xs'}
            h={8}
            variant={'solid'}
            key={text}
            onClick={() => onPresetClick({ startDate: start, endDate: end })}
          >
            {text}
          </Button>
        )
      })}
    </Flex>
  )
}
